<template>
    <div>
        <app-form-select-input
            label="Tipo de estructura"
            :options="structureTypes"
            :hasError="$v.theStructure.typeId.$error"
            errorMessage="Debe seleccionar la estructura"
            @change="$v.theStructure.typeId.$touch()"
            v-model="theStructure.typeId"
            :required="true"
        ></app-form-select-input>

        <app-form-select-input
            label="Sede"
            :options="venues"
            v-model="theStructure.venueId"
            :has-error="$v.theStructure.venueId.$error"
            error-message="Debe seleccionar la sede"
            :required="true"
            @change="$v.theStructure.venueId.$touch()"
        />

        <app-form-text-input
            label="Nombre"
            id="name"
            :required="true"
            :hasError="$v.theStructure.name.$error"
            errorMessage="Debe escribir el nombre"
            @input="$v.theStructure.name.$touch()"
            v-model="theStructure.name"
        ></app-form-text-input>

        <app-form-text-input
            label="Telefono"
            id="phone"
            v-model="theStructure.phone"
        ></app-form-text-input>
        <app-form-text-input
            label="Extensión"
            id="extencion"
            v-model="theStructure.extension"
        ></app-form-text-input>
        <app-form-text-input
            label="E-mail"
            id="email"
            :hasError="$v.theStructure.email.$error"
            errorMessage="Debe escribir un email valido"
            @input="$v.theStructure.email.$touch()"
            v-model="theStructure.email"
        ></app-form-text-input>
    </div>
</template>
<script>
import userRepository from "../../../repositories/users.repository.js";
import FormTextInput from "../../UI/Controls/Forms/FormTextInput.vue";
import FormSelectInput from "../../UI/Controls/Forms/FormSelectInput.vue";
import { required, email, numeric } from "vuelidate/lib/validators";
import {
    alphaSpaces,
    alphaNumericNoSpaces
} from "../../../utils/CustomValidators";
import structuresRepository from "../../../repositories/structures.repository.js";
import clientsRepository from "../../../repositories/clients.repository";
import { mapGetters } from "vuex";

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput
    },

    props: {
        myClient: {
            default: null
        },
        onSave: {
            type: Function
        }
    },

    data() {
        return {
            theStructure: {
                clientId: "",
                typeId: "",
                name: "",
                phone: "",
                email: "",
                extension: "",
                venueId: ""
            },
            venues: []
        };
    },
    watch: {
        myClient(val) {
            this.loadVenues();
        }
    },
    validations: {
        theStructure: {
            name: { required },
            email: { email },
            typeId: { required },
            venueId: { required }
        }
    },
    computed: {
        ...mapGetters({
            theStructureTypes: "structureTypes"
        }),
        structureTypes() {
            return this.theStructureTypes.filter(item => !item.access_point);
        }
    },
    methods: {
        registerStructure() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            this.theStructure.clientId = this.myClient.id;
            const sr = Object.assign({}, structuresRepository);
            sr.saveStructure(this.theStructure)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        Object.keys(this.theStructure).map(
                            key => (this.theStructure[key] = "")
                        );
                        this.$v.$reset();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al guardar la estructura");
                });
        },
        cleanFields() {
            Object.keys(this.theStructure).map(
                key => (this.theStructure[key] = "")
            );
            this.$v.$reset();
        },
        loadVenues() {
            const cr = { ...clientsRepository };

            cr.getVenuesByClient(this.myClient.id)
                .then(venues => (this.venues = venues))
                .catch(error =>
                    toastr.error(
                        "Ocurrió un error al cargar las sedes del cliente"
                    )
                );
        }
    },

    created() {
        this.load("structureTypes");
        this.loadVenues();
        this.cleanFields();
        this.$bus.$on("structure-form.save", this.registerStructure);
        this.$bus.$on("structure-form.clean", this.cleanFields);
    },
    beforeDestroy() {
        this.$bus.$off("structure-form.save");
    }
};
</script>
